import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import Airplanes from "../../../assets/client/airplanes.svg?react";
import styles from "./VirtualInterliningBanner.module.scss";

export interface IVirtualInterliningBannerProps {
  modal?: boolean;
}

export const VirtualInterliningBanner = ({
  modal,
}: IVirtualInterliningBannerProps) => {
  const { t } = useI18nContext();

  return (
    <div className={clsx(styles.VirtualInterliningBanner, { modal })}>
      <Airplanes className={styles.VirtualInterliningBannerIcon} />
      <div className={styles.VirtualInterliningBannerContent}>
        {t("multipleItineraries")}
      </div>
    </div>
  );
};
